import React, { Fragment } from "react";
import { Parallax } from "react-scroll-parallax";
import { ReactSVG } from "react-svg";
import Media from "react-media";
import { MOBILE_WIDTH } from "../../constants";
import Showcase from "../common/Showcase";
import barChart from "../../assets/shapes/barChart.svg";
import triangle from "../../assets/shapes/triangle.svg";
import upRightArrow from "../../assets/shapes/upRightArrow.svg";
import upLeftArrow from "../../assets/shapes/upLeftArrow.svg";
import beamPat from "../../assets/shapes/beamPat.svg";

import styles from "./Progress.module.scss";
import imageSource from '../../assets/screenshots/5-patternDetail.png'

const patternDetail = {
  title: "Progress",
  content:
    "These views will give you a look at your consistency or lack thereof allowing you to know where you are killing it and where you have room for improvement.",
  featureTitle: "Features",
  features: [
    "Adjustable time increments, providing you a big picture view.",
    "Pattern score based on consistency."
  ],
  imageSource
};

const Progress = props => {
  const {
    centerCluster,
    centerStyle,
    center,
    centerSM,
    border,
    triangleStyle,
    primaryOrange,
    shapeCluster,
    left,
    right
  } = styles;

  return (
    <Fragment>
      <Showcase item={patternDetail} bubbleStyle={border}>
        <Parallax translateY={[-100, 170]} className={triangleStyle}>
          <ReactSVG src={triangle} />
        </Parallax>

        <div className={centerCluster}>
          <Parallax translateY={[100, -100]}  className={centerStyle}>
            <Media query={{ maxWidth: MOBILE_WIDTH }}>
              {matches => (
                <ReactSVG
                  src={barChart}
                  className={`${matches ? centerSM : center}`}
                />
              )}
            </Media>
          </Parallax>
        </div>

        <div className={shapeCluster}>
          <Parallax translateY={[-155, -15]} className={right}>
            <ReactSVG src={upRightArrow} />
          </Parallax>

          <ReactSVG src={beamPat} style={{ fill: primaryOrange }} />

          <Parallax translateY={[200, -10]} className={left}>
            <ReactSVG src={upLeftArrow} />
          </Parallax>
        </div>
      </Showcase>
    </Fragment>
  );
};

export default Progress;
